import sectionCustomizeCardCss from '../css-snippets/section-customize-card';

const html = `
<style>${sectionCustomizeCardCss}</style>
<div data-attribute="card-container" data-background="#EBE6E2" style="background-color: #EBE6E2;"
  data-top-padding="true" data-bottom-padding="true">
  <div class="container-page" data-attribute="container-page" data-show-style="true" data-background="#FFFFFF"
    style="background-color: rgb(255, 255, 255);">
    <div class="wrap-card container">
      <div data-attribute="card-item-content" data-order="2" class="card-left" data-style-center-y="false"
        style="order: 2;">
        <div data-attribute="card-rated-row" data-show-rating="false" style="display: none;">
          <div class="wrap-rated">
            <div data-attribute="rating-stars" data-value="4" class="wrap-stars">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
            </div>
            <div data-attribute="rating-text" class="wrap-rating">Rated 4.9/5 by 12,000+ happy pet owners</div>
          </div>
        </div>
        <div data-attribute="card-content" class="card-content">
          <div data-attribute="card-title">
            <h2><span style="background-color:rgb(255,255,255);"><strong>Upgrade every ride and protect what matters
                  most.</strong></span></h2>
          </div>
          <div data-attribute="card-description">
            <p>Drive cleaner, safer, and calmer with the bold Waterproof Dog Car Seat Cover with Hard Bottom, and your
              car spotless protection, every single trip.</p>
            <p>Our promise? We deliver peace of mind with the bold Waterproof Dog Car Seat Cover with Hard Bottom,
              backed by a 30-day satisfaction guarantee and fast, trackable shipping. Whether it’s muddy paws, nervous
              pups, or backseat chaos.</p>
          </div>
        </div>
        <div data-attribute="card-btn-row" data-show-btn="true" class="row-btn" style="display: block;">
          <a data-attribute="card-btn" class="card-btn" href="#">👉 Buy Now</a>
          <div data-attribute="sub-btn" class="sub-btn">Enjoy free shipping and a relaxed 30-day return period.</div>
        </div>
      </div>
      <div data-attribute="card-item-image" data-order="1" class="card-right" style="order: 1;">
        <div class="wrap-img">
          <img loading="lazy" data-attribute="card-image" class="card-image"
            src="https://cdn.cacheimg.com/Admin-Lattehub/2025/08/04/image-6890857f35b9e65d6c190e9f.jpg?w=500" alt="">
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
